// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"92":"36821e01","585":"6705561a"}[chunkId] + ".js";
};